module.exports = __webpack_public_path__ + "static/media/right_candy_cane.e25d8246.svg";